import { render } from "./FileTypeIcon.vue?vue&type=template&id=a1eb0d5a&scoped=true"
import script from "./FileTypeIcon.vue?vue&type=script&lang=js"
export * from "./FileTypeIcon.vue?vue&type=script&lang=js"

import "./FileTypeIcon.vue?vue&type=style&index=0&id=a1eb0d5a&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1eb0d5a"]])

export default __exports__